import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ValidationPipe } from "src/app/shared/components/ui/validation.pipe";
import {
  DrProfile,
  DrProfileWizardStepEnum,
} from "src/app/shared/models/order.model";
import { AppState } from "src/app/shared/redux/store";
import { BroshService } from "src/app/shared/services/brosh.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { EditProfileRxComponent } from "./edit-profile-rx/edit-profile-rx.component";
import { EditProfileAutoApproveComponent } from "./edit-profile-auto-approve/edit-profile-auto-approve.component";
import { EditProfileNotesComponent } from "./edit-profile-notes/edit-profile-notes.component";
import { EditProfilePgComponent } from "./edit-profile-pg/edit-profile-pg.component";
import { EditProfileSignComponent } from "./edit-profile-sign/edit-profile-sign.component";
import { AuthService } from "src/app/shared/services/auth.service";
import { CommonModule } from "@angular/common";

class TrackerStep {
  stepId: number;
  text: string;
  stepCode: string;
}

@Component({
  selector: "edit-dr-profile-wizard",
  templateUrl: "./edit-dr-profile-wizard.component.html",
  styleUrls: ["./edit-dr-profile-wizard.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    EditProfileSignComponent,
    EditProfilePgComponent,
    EditProfileAutoApproveComponent,
    EditProfileNotesComponent,
    EditProfileRxComponent,
  ],
})
export class EditDrProfileWizardComponent {
  @ViewChild(EditProfileRxComponent)
  public vcRx: EditProfileRxComponent;

  @ViewChild(EditProfileAutoApproveComponent)
  public vcAutoApprove: EditProfileAutoApproveComponent;

  @ViewChild(EditProfileNotesComponent)
  public vcNotes: EditProfileNotesComponent;

  @ViewChild(EditProfilePgComponent)
  public vcPg: EditProfilePgComponent;

  @ViewChild(EditProfileSignComponent)
  public vcSign: EditProfileSignComponent;

  @Input() data: DrProfile;
  @Output() onCancel = new EventEmitter();
  @Output() onSave = new EventEmitter();

  saving: boolean;
  steps: TrackerStep[] = [];
  curStep: TrackerStep;
  allowEditPG: boolean;

  get profileDescr(): string {
    let descr = "";
    if (this.data.doctor) {
      descr += this.data.doctor.text;
    }
    if (this.data.clinic) {
      if (this.data.doctor) {
        descr += " | ";
      }
      descr += this.data.clinic.text;
    }
    return descr;
  }

  constructor(
    private sharedService: SharedService,
    private authService: AuthService,
    private broshService: BroshService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.allowEditPG = this.authService.currentUser.authDetails.getBooleanValue(
      "MNG.DR_PROFILE.PG_ALLOWED_SW"
    );

    this.addStep(
      DrProfileWizardStepEnum.RX_OPT_FIXED,
      this.translateService.instant("translate.mng.prefType.RX_OPT_FIXED")
    );
    this.addStep(
      DrProfileWizardStepEnum.RX_OPT_REMOVABLE,
      this.translateService.instant("translate.mng.prefType.RX_OPT_REMOVABLE")
    );
    this.addStep(
      DrProfileWizardStepEnum.AUTO_APPROVE,
      this.translateService.instant("translate.mng.prefType.AUTO_APPROVE")
    );
    if (this.allowEditPG)
      this.addStep(
        DrProfileWizardStepEnum.PERSONAL_GUIDANCE,
        this.translateService.instant(
          "translate.mng.prefType.PERSONAL_GUIDANCE"
        )
      );
    this.addStep(
      DrProfileWizardStepEnum.NOTE,
      this.translateService.instant("translate.mng.prefType.NOTE")
    );
    this.addStep(
      DrProfileWizardStepEnum.SIGN,
      this.translateService.instant("translate.mng.signature")
    );

    this.curStep = this.steps[0];
  }

  addStep(stepCode: string, text: string) {
    this.steps.push({
      stepId: this.steps.length + 1,
      text: text,
      stepCode: stepCode,
    });
  }

  public closePanel() {
    this.onCancel.emit();
  }

  isCur(step: TrackerStep): boolean {
    return step == this.curStep;
  }

  isPast(step: TrackerStep): boolean {
    return step.stepId < this.curStep.stepId;
  }

  isFuture(step: TrackerStep): boolean {
    return step.stepId > this.curStep.stepId;
  }

  back() {
    this.saveStep();
    this.curStep = this.steps[this.steps.indexOf(this.curStep) - 1];
  }

  next() {
    this.saveStep();
    this.curStep = this.steps[this.steps.indexOf(this.curStep) + 1];
  }

  saveStep() {
    switch (this.curStep.stepCode) {
      case DrProfileWizardStepEnum.RX_OPT_FIXED:
        this.vcRx.save();
        break;
      case DrProfileWizardStepEnum.RX_OPT_REMOVABLE:
        this.vcRx.save();
        break;
      case DrProfileWizardStepEnum.AUTO_APPROVE:
        this.vcAutoApprove.save();
        break;
      case DrProfileWizardStepEnum.NOTE:
        this.vcNotes.save();
        break;
      case DrProfileWizardStepEnum.PERSONAL_GUIDANCE:
        this.vcPg.save();
        break;
      case DrProfileWizardStepEnum.SIGN:
        this.vcSign.save();
        break;
      default:
        break;
    }

    console.log(this.data);
  }

  save() {
    this.saving = true;
    this.broshService.updDrProfile(this.data).subscribe(
      (data) => {
        this.saving = false;
        this.onSave.emit();
      },
      () => (this.saving = false)
    );
  }
}
